function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.14 11.143V1.857H1.86v9.286h16.28zM0 .925C0 .414.418 0 .931 0H19.07A.93.93 0 0 1 20 .925v11.15c0 .511-.418.925-.931.925H.93A.93.93 0 0 1 0 12.075V.925zm3.78.931l6.23 5.153 6.238-5.158-12.468.005zm8.55 4.894l-.777.62-.817.652c-.4.32-1.052.318-1.453-.003l-.756-.603-.847-.676-.42.46-4.65 5.108-.47.515-1.033-.937.47-.515 4.65-5.107.361-.396L.722 1.186H19.3L13.42 5.878l.351.386 4.651 5.107.47.515-1.033.937-.47-.515L12.74 7.2l-.41-.451z",
  fillRule: "nonzero"
});

var SvgEnvelope = function SvgEnvelope(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 13",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEnvelope, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Envelope.8873deeb.svg";
export { ForwardRef as ReactComponent };